module.exports = __webpack_public_path__ + "static/media/googleplay.b7ff1886.png";